import React, { useMemo } from 'react';
import { IItemForGetShortInfo } from 'types';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './Info.module.scss';

interface IProps {
	customerName: string;
	categoryName: string;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
	activationSchedule: string;
	deactivationSchedule: string;
	availableForRepetition: boolean;
	isHidden: boolean;
}

export const Info: React.FC<IProps> = React.memo(
	({
		customerName,
		categoryName,
		fetchedRestaurants,
		IDSelectedRestaurantOnRestPropsPage,
		activationSchedule,
		deactivationSchedule,
		availableForRepetition,
		isHidden,
	}) => {
		const { t } = useTranslation('form');
		const availableForRepetitionValue = availableForRepetition ? t('yes') : t('no');
		const isHiddenValue = isHidden ? t('yes') : t('no');

		const restaurantName = useMemo(() => {
			return (
				fetchedRestaurants.find((restaurant) => restaurant.id === IDSelectedRestaurantOnRestPropsPage)?.name ||
				'-'
			);
		}, [fetchedRestaurants, IDSelectedRestaurantOnRestPropsPage]);

		return (
			<div className={style.container}>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="customerLabel"
						value={customerName}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="restaurantLabel"
						value={restaurantName}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="categoryLabel"
						value={categoryName}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="activationScheduleLabel"
						value={activationSchedule}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="deactivationScheduleLabel"
						value={deactivationSchedule}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="availableForRepetitionLabel"
						value={availableForRepetitionValue}
						prefixIcon="asCheckbox"
						prefixIconName={availableForRepetition ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={availableForRepetition}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="hideSubcategoryLabel"
						value={isHiddenValue}
						prefixIcon="asCheckbox"
						prefixIconName={isHidden ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={isHidden}
						useInForm={true}
					/>
				</div>
			</div>
		);
	},
);
